import { action } from 'satcheljs';

/**
 * Orchestrator corresponding to this action is defined in owa-calendar-options-store under owa-calendar.
 */
export default action('updateSurfaceOptions') as () => {};
